module.exports = __webpack_public_path__ + "static/asdf8asdf-d529567df5622f30029edacbe4329ba6.png";